import { BOOLEAN_STRINGS } from 'shared/constants';
import { getCookie } from 'helpers/utils/cookie';
import { BrandsPart } from 'store/product/types';

export const reviewCookie =
  (typeof window !== 'undefined' && getCookie('N_RVWS')) ||
  BOOLEAN_STRINGS.FALSE;

export const showNewTitle = (productTitle: string, brandInfo: BrandsPart[]) => {
  if (!productTitle || !brandInfo || brandInfo?.length === 0) return false;
  for (const brand of brandInfo) {
    if (!brand.id || !brand.name) {
      return false;
    }
  }
  return true;
};

export const BRAND_TITLE_CLICK = 'brand_title_click';
export const DOWNLOAD_STRIP_SHOWN = 'DownloadStripShown';
export const NO_AF_URL = 'no url generated';
export const NO_AF_FALLBACK_URL = '/';
